import {BaseAppModel} from "./AppModel";
import Device from "@/model/Device";

export default class ProductActivation extends BaseAppModel<ProductActivation> {
    sequence!: number
    activeCode!: string
    usable!: boolean
    isValid!: boolean
    deletable!: boolean
    isPrinted!: boolean
    batchCode?: string

    device!: Device
}
